import { CountryDto, CountrySearchRequest, UpsertCountryDto } from 'ts-types/api.types';
import axios from './http';
import { CancelTokenSource } from 'axios';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/countries`;

export const getAllCountries = (source: CancelTokenSource): Promise<Array<CountryDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchCountries = (countriesSearchRequest: Partial<CountrySearchRequest>,
                                source: CancelTokenSource): Promise<Array<CountryDto>> => {
  return axios
      .post(`${apiUri}/search`,countriesSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const findCountryById = (id: number, source: CancelTokenSource): Promise<UpsertCountryDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const addCountry = (upsertCountryDto: Partial<UpsertCountryDto>, source: CancelTokenSource): Promise<CountryDto> => {
  return axios
      .post(apiUri, upsertCountryDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editCountry = (id: number, upsertCountryDto: Partial<UpsertCountryDto>, source: CancelTokenSource): Promise<CountryDto> => {
  return axios
      .put(`${apiUri}/${id}`,upsertCountryDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteCountry = (id: number, source: CancelTokenSource): Promise<CountryDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
